up.compiler('[invoice-wizard-link]', (element) => {

  element.addEventListener('click', () => {
    let form = element.closest('form')
    let params = up.Params.fromForm(form)

    element.setAttribute('href', buildURL(params))
  })

  function buildURL(params) {
    let url = new URL(element.href)
    let selectedIncomingInvoices = params.entries
      .filter(entry => entry.name === 'selected_incoming_invoice_ids[]')

    if (!url.searchParams.has('selected_incoming_invoice_ids[]')) {
      selectedIncomingInvoices.forEach((entry) => {
        url.searchParams.append('selected_incoming_invoice_ids[]', entry.value)
      })
    }

    return url.href
  }
})
